// Runs before Gatsby's external scripts; it cannot authenticate, clear accounts
// or create payments. Reload occurs only after the user presses the retry button.
export const loginBootScript = `(function(){
 var box=document.getElementById('op-login-boot');
 if(!box)return;
 var message=document.getElementById('op-login-boot-message');
 var retry=document.getElementById('op-login-boot-retry');
 var done=false;
 function delayed(){if(done)return;message.textContent='連線較慢，仍在載入登入頁。你可以稍候或重新載入。';retry.style.display='inline-block';}
 var timer=window.setTimeout(delayed,15000);
 function failed(event){if(event.target&&event.target.tagName==='SCRIPT')delayed();}
 window.addEventListener('error',failed,true);
 retry.onclick=function(){if(!done)window.location.reload();};
 window.__opSdkLoginBootDone=function(){
  if(done)return;done=true;window.clearTimeout(timer);window.removeEventListener('error',failed,true);
  if(box.parentNode)box.parentNode.removeChild(box);
  delete window.__opSdkLoginBootDone;
 };
}());`;

export function completeLoginBoot() {
    if (typeof window !== "undefined" && typeof window.__opSdkLoginBootDone === "function") {
        window.__opSdkLoginBootDone();
    }
}
